<template>
  <div>
    <div
      class="content-devx content-dx-daily-planning"
    >
      <DxForm
        id="formPrecription"
      >
        <DxSimpleItem
          name="subfamily"
          :data-field="$t('DxPlanningProducts_typePrescription')"
          editor-type="dxSelectBox"
          :editor-options="{
            readOnly: readOnly,
            items: typePrescription,
            value: actualSubFamily,
            displayExpr: 'name',
            valueExpr:'id',
            onValueChanged: onChangeSubFamily,
            searchEnabled: true,
            searchTimeout: searchTimeoutOption,
            minSearchLength: minSearchLengthOption,
            showDataBeforeSearch: showDataBeforeSearchOption,
          }"
        >
          <DxRequiredRule :message="$t('DxPlanningProducts_typePrescription_required')" />
        </DxSimpleItem>
        <DxSimpleItem
          name="component"
          :data-field="$t('DxPlanningProducts_prescription')"
          editor-type="dxSelectBox"
          :editor-options="{
            readOnly: readOnly,
            items: listComponents,
            value: actualComponent,
            displayExpr: 'name',
            valueExpr:'id',
            onValueChanged: onChangeComponent,
            searchEnabled: true,
            searchTimeout: searchTimeoutOption,
            minSearchLength: minSearchLengthOption,
            showDataBeforeSearch: showDataBeforeSearchOption,
          }"
        >
          <DxRequiredRule :message="$t('DxPlanningProducts_prescription_required')" />
        </DxSimpleItem>
      </DxForm>

      <DxDataGrid
        id="productsGrid"
        ref="productsGrid"
        :data-source="actualTaskBadget.products"
        :column-min-width="70"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="false"
        :row-alternation-enabled="true"
        @row-updated="onChangeRow"
      >
        <DxEditing
          :allow-updating="true"
          :allow-deleting="false"
          :allow-adding="false"
          mode="row"
        />
        <DxColumn
          data-field="product.description"
          name="product.description"
          :caption="$t('DxProducts_dxColumn_productName')"
          :allow-editing="false"
          :width="120"
        >
          <DxRequiredRule />
        </DxColumn>
        <DxColumn
          data-field="dosis"
          name="dosis"
          data-type="number"
          :caption="$t('DxProducts_dxColumn_dosis')"
        >
          <DxRequiredRule />
        </DxColumn>
        <DxColumn
          data-field="dosisUt"
          name="dosisUt"
          :caption="$t('DxProducts_dxColumn_dosisUt')"
          :allow-editing="false"
        />
        <DxColumn
          data-field="dosis_total"
          name="dosis_total"
          :allow-editing="false"
          :caption="$t('DxProducts_dxColumn_dosisTotal')"
          :calculate-cell-value="calculateDosisTotal"
          alignment="right"
        />
      </DxDataGrid>

      <DxDataGrid
        id="dxSolutionGrid"
        ref="dxSolutionGrid"
        :data-source="getFirstRowSolution(actualTaskBadget.products)"
        :column-min-width="70"
        :allow-column-reordering="true"
        :show-borders="true"
        :show-column-lines="true"
        :column-auto-width="true"
        :show-row-lines="false"
        :row-alternation-enabled="true"
        style="margin-top: 20px;"
        @row-updated="updatedSolutionVuex"
      >
        <DxEditing
          :allow-updating="true"
          :allow-deleting="false"
          :allow-adding="false"
          mode="row"
        />
        <DxColumn
          data-field="solution"
          name="solution"
          data-type="number"
          alignment="right"
          :caption="$t('DxProducts_dxColumn_solution_total')"
          :format="dosisColumnFormat"
          :editor-options="dosisEditorFormat"
        >
          <DxRequiredRule />
        </DxColumn>
        <DxColumn
          data-field="solutionUt"
          name="solutionUt"
          alignment="left"
          data-type="string"
          :caption="$t('DxProducts_dxColumn_solutionUt')"
          :allow-editing="false"
        />
        <DxColumn
          data-field="dilution_factor"
          name="dilution_factor"
          data-type="number"
          alignment="right"
          :allow-editing="false"
          :caption="$t('DxProducts_dxColumn_dilutionFactor')"
          :format="dosisColumnFormat"
          :editor-options="dosisEditorFormat"
          :calculate-cell-value="calculateDilutionFactor"
        />
        <!-- Water Planned (L) -->
        <DxColumn
          data-field="solution_total"
          name="solution_total"
          :allow-editing="false"
          :caption="$t('DxProducts_dxColumn_solutionTotal')"
          alignment="right"
          :calculate-cell-value="calculateTotalSolution"
        />
      </DxDataGrid>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import * as overlay from 'devextreme/ui/overlay';
import Api from '../../services/Api';
import EventBus from '../../js/event-bus';

export default {
  name: 'DxProducts',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxRequiredRule,
    DxForm,
    DxSimpleItem,
  },
  props: {
    readOnly: { type: Boolean, default: () => false },
    editForm: { type: Boolean, default: false },
  },
  data() {
    return {
      family: [],
      subfamily: [],
      product: [],
      listPrescriptions: [],
      actualSubFamily: '',
      actualComponent: '',
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
      searchTimeoutOption: 200,
      dosisColumnFormat: { type: 'fixedPoint', precision: 2 },
      dosisEditorFormat: { format: { type: 'fixedPoint', precision: 2 } },
      solutionsFormated: [],
      products: [],
    };
  },
  computed: {
    ...mapState('PlanningManager', ['workingArea']),
    ...mapGetters('TaskBadget', ['actualTaskBadget']),
    ...mapState('Prescription', ['listFamily', 'typePrescription', 'listComponents']),
  },
  destroyed() {
    EventBus.$off('changeTotalAreaSelected');
  },
  async beforeMount() {
    overlay.baseZIndex(9999);
    const xhr = await Api.getDataSubfamilyByType('product');
    this.setData(JSON.parse(xhr.response));
    const xhr2 = await Api.getPrescriptions();
    this.listPrescriptions = JSON.parse(xhr2.response);
    EventBus.$on('changeTotalAreaSelected', this.calculateDoseSolution);
    if (this.editForm && this.actualTaskBadget.prescription != null) {
      this.products = JSON.parse(JSON.stringify(this.actualTaskBadget.products));
      // Modo edición
      // Seteo subfamilia, filtrando por la familia seleccionada
      this.actualSubFamily = this.actualTaskBadget.prescription.type;
      this.setlistSubfamily(this.subfamily);

      // Seteo las prescripciones filtradas:
      this.actualComponent = this.actualTaskBadget.prescription.id;
      const arrayComponent = this.listPrescriptions.filter(
        (elemento) => elemento.type === this.actualTaskBadget.prescription.type && elemento.active === 'Yes',
      );
      await this.setlistComponents(arrayComponent);
      this.setProducts(this.products);
      this.calculateDoseSolution();
    } else {
      this.setNewPrescription();
    }
  },
  beforeDestroy() {
    this.setNewPrescription();
  },
  methods: {
    getFirstRowSolution() {
      if (this.actualTaskBadget.products.length > 0) {
        return [this.actualTaskBadget.products[0]];
      }
      return [];
    },
    isKilogrameOrliter(rowData) {
      return typeof (rowData.dosisUt) === 'undefined' || rowData.dosisUt.toLowerCase().includes('kg/') || rowData.dosisUt.toLowerCase().includes('l/');
    },
    calculateDilutionFactor(rowData) {
      const value = typeof (rowData.solution) === 'undefined' ? '' : `${rowData.solution / 100}`;
      return value;
    },
    calculateDosisTotal(rowData) {
      let calcDosisTotal = (parseFloat(rowData.dosis) * parseFloat(this.workingArea)).toFixed(2);
      const dilutionFactor = parseFloat(rowData.solution) / 100;
      const unit = this.calculateUnitDosisTotal(rowData);

      calcDosisTotal = (!this.isKilogrameOrliter(rowData)) ? ((calcDosisTotal * dilutionFactor) / 1000).toFixed(2) : calcDosisTotal;
      return `${calcDosisTotal} ${unit}`;
    },
    calculateUnitDosisTotal(rowData) {
      if (rowData.dosisUt.toLowerCase().includes('gr/')
        || rowData.dosisUt.toLowerCase().includes('kg/')) return 'Kg';
      return 'L';
    },
    // calculateTotalSolution(rowData) {
    //   if (this.isKilogrameOrliter(rowData)) {
    //     return '';
    //   }
    //   return (rowData.solution * this.workingArea).toFixed(2);
    // },
    calculateTotalSolution(rowData) {
      return (rowData.solution * this.workingArea).toFixed(2);
    },
    setData(dataArray) {
      this.family.length = 0;
      this.subfamily.length = 0;
      this.product.length = 0;
      for (let i = 0; i < dataArray.length; i += 1) {
        this.family.push({
          id: dataArray[i].id,
          name: dataArray[i].id,
        }); // PHITOSANITARY / SUBSTRATE / FERTILIZERS
        const subfami = dataArray[i].items;
        for (let j = 0; j < subfami.length; j += 1) {
          this.subfamily.push({
            id: subfami[j].id,
            name: subfami[j].id,
            family_id: dataArray[i].id,
          }); // <-- subfamily

          const component = subfami[j].items;
          for (let k = 0; k < component.length; k += 1) {
            if (dataArray[i].id === 'PHITOSANITARY') {
              // En caso de fitosanitario, los productos estan un nivel mas adentro
              const prod = component[k].items;
              for (let n = 0; n < prod.length; n += 1) {
                this.product.push({
                  id: prod[n].id,
                  name: prod[n].description,
                  subfamily_id: subfami[j].id,
                });
              }
            } else {
              // En caso contrario, los productos son directamente el componente
              this.product.push({
                id: component[k].id,
                name: component[k].description,
                subfamily_id: subfami[j].id,
              });
            }
          }
        }
      }
      this.setlistFamily(this.family);
    },
    onChangeSubFamily(e) {
      this.actualSubFamily = e.value;
      const arrayFiltrado = this.listPrescriptions.filter(
        (elemento) => elemento.type === e.value && elemento.active === 'Yes',
      );
      this.setlistComponents(arrayFiltrado);
      this.actualComponent = '';
      this.setProducts([]);
      this.setPrescription([]);
      EventBus.$emit('updateCosts');
    },
    onChangeComponent(e) {
      this.actualComponent = e.value;
      const arrayFiltrado = this.listPrescriptions.filter(
        (elemento) => elemento.id === e.value,
      );
      this.setPrescription(arrayFiltrado[0]);
      this.setProducts(arrayFiltrado[0].products);
      this.calculateDoseSolution();
    },
    // SET DATA SOURCE TO PRODUCTS VUEX
    updatedProductsVuex() {
      this.products = this.actualTaskBadget.products;
      for (let i = 0; i < this.products.length; i += 1) {
        const item = this.products[i];
        if (item.dosisUt.includes('Ha')) {
          this.products[i].solution = '0.00';
          this.products[i].solutionUt = '';
          this.products[i].dilution_factor = '0.00';
        } else {
          this.products[i].solutionUt = 'L/Ha';
          this.products[i].dilution_factor = parseFloat(item.solution) / 100;
        }
      }
      this.setProducts(this.products);
    },
    // SET DATA SOURCE TO PRODUCTS VUEX
    updatedSolutionVuex(e) {
      const products = [...this.actualTaskBadget.products];
      for (let i = 0; i < this.actualTaskBadget.products.length; i += 1) {
        if (products[i].dosisUt.includes('Ha')) {
          products[i].solution = 0;
          products[i].dilution_factor = 0.00;
          products[i].solutionUt = 'L/Ha';
        } else {
          products[i].solution = e.data.solution;
          products[i].solutionUt = 'L/Ha';
          products[i].dilution_factor = parseFloat(e.data.solution) / 100;
        }
      }
      this.setProducts(products);
      this.calculateDoseSolution();
    },
    onChangeRow() {
      this.setProducts(this.$refs.productsGrid.instance.getDataSource().items());
      this.calculateDoseSolution();
    },
    calculateDoseSolution() {
      if (this.actualTaskBadget.products.length > 0) {
        for (let i = 0; i < this.actualTaskBadget.products.length; i += 1) {
          const producto = this.actualTaskBadget.products[i];
          let dosisTotal = 0;
          let solutionTotal = 0;
          const dilutionFactor = producto.solution / 100;
          if (producto.dosisUt.toLowerCase().includes('gr/')
          || producto.dosisUt.toLowerCase().includes('cc/')) {
            solutionTotal = parseFloat(dilutionFactor) * parseFloat(this.workingArea);
          } else {
            solutionTotal = 0;
          }

          if (producto.dosisUt.toLowerCase().includes('gr/')
          || producto.dosisUt.toLowerCase().includes('cc/')) {
            dosisTotal = (parseFloat(producto.dosis) * parseFloat(solutionTotal)
             * parseFloat(this.workingArea)) / 1000;
          } else {
            dosisTotal = parseFloat(producto.dosis) * parseFloat(this.workingArea);
          }
          this.actualTaskBadget.products[i].dosis_total = dosisTotal.toFixed(2).toString();
          this.actualTaskBadget.products[i].solution_total = solutionTotal.toFixed(2).toString();
          this.actualTaskBadget.products[i].dilution_factor = dilutionFactor.toFixed(2).toString();
        }
        this.setProducts(this.actualTaskBadget.products);
        EventBus.$emit('updateCosts');
      }
    },
    ...mapActions('Prescription', ['setlistFamily', 'setlistSubfamily', 'setlistComponents']),
    ...mapActions('TaskBadget', ['setPrescription', 'setProducts', 'setNewPrescription']),
  },
};
</script>
